import { render, staticRenderFns } from "./ListProcesoElectoral.vue?vue&type=template&id=51d6f2c7"
import script from "./ListProcesoElectoral.vue?vue&type=script&lang=js"
export * from "./ListProcesoElectoral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports